import * as _actions from './actions';
import * as _accessors from './accessors';
import _reducer from './reducer';
import _PersonalisedHomework from './model';

_PersonalisedHomework.actions = _actions;
_PersonalisedHomework.accessors = _accessors;

export const actions = _actions;
export const accessors = _accessors;
export const reducer = _reducer;
export const PersonalisedHomework = _PersonalisedHomework;



// WEBPACK FOOTER //
// ./data/OnlineHomework/Personalised/index.js